import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'dr-upgrade-dialog',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './upgrade-dialog.component.html',
    styleUrls: ['./upgrade-dialog.component.scss'],
})
export class UpgradeDialogComponent {
    private readonly dialogRef = inject(MatDialogRef<UpgradeDialogComponent>);

    illustrationUrl = `${environment.staticBaseUrl}/static/images/upgrade-financeos-illustration.png`;

    close(): void {
        this.dialogRef.close();
    }
}
